var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1319 5.0401C28.6064 1.72658 25.6228 0.639477 22.9653 0.207858C19.5446 -0.348747 15.9728 1.30163 13.9341 4.20797C10.53 -1.03701 2.607 -0.280422 0.438353 5.6767C-0.969825 9.54239 1.27271 14.0124 3.51079 16.9838C6.4127 20.8356 10.6028 23.6225 14.7396 25.5928C14.9323 25.6851 15.0951 25.6362 15.2145 25.5301C15.3262 25.5812 15.4573 25.5906 15.5989 25.5223C17.5459 24.5891 19.0102 23.0326 20.6006 21.5427C22.4415 19.8196 24.3457 18.287 25.9972 16.3261C28.8358 12.9581 29.8662 9.67182 29.1319 5.0401ZM23.3169 17.662C21.0289 20.0285 18.0731 23.112 15.1684 24.5057C15.1373 24.5207 15.1206 24.5435 15.0962 24.5624C9.0163 21.6666 0.817201 15.7745 1.10661 7.62204C1.34992 0.744466 10.4095 0.146754 13.373 5.25286C13.4886 5.45228 13.6497 5.50339 13.8024 5.47228C14.008 5.61448 14.2818 5.62115 14.4535 5.34229C16.3327 2.29152 19.5207 1.02832 22.8614 1.30829C26.7616 1.63603 28.3058 4.14242 28.3736 8.14976C28.4442 12.3232 25.8878 15.0029 23.3169 17.662Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.11417950781a57f23042e05cad2257c2.svg";
export { ForwardRef as ReactComponent };